/**
 * UI-6b Task 6 — SlaGauge widget manifest registration.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import { SlaGaugeRenderer, type SlaGaugeConfig } from './Renderer.js'
import { SlaGaugeConfigEditor } from './ConfigEditor.js'

export const slaGaugeManifest: WidgetManifest<SlaGaugeConfig> = {
  type: 'sla-gauge',
  label: 'SLA Gauge',
  description: 'Service-level agreement percentage for a queue (last 24h).',
  defaultSize: '1x1',
  defaultConfig: { queueId: '', targetPercent: 90 },
  Renderer: SlaGaugeRenderer,
  ConfigEditor: SlaGaugeConfigEditor,
}

registerWidget(slaGaugeManifest)
